import { useMemo } from "react";
import { useRefreshAssetPath } from "#src/hooks";
import { useTemplateData } from "./useTemplateData";
import { useTemplateEditorStore } from "../store/useTemplateEditorStore";
import { resolveMainImageMediaType } from "../helpers/itemsHelper";

export const useMainImageAssetPath = () => {
  const {
    storyboardWithSlidesData: { slides },
    placeholderAssets,
  } = useTemplateData();

  const { mainImage, currentItem, currentSlide } = useTemplateEditorStore(
    (store) => ({
      mainImage: store.templateState.mainImage,
      currentItem: store.templateState.currentItem,
      currentSlide: store.currentSlide,
    })
  );

  const currentMainImage =
    mainImage?.id === currentItem?.id ? mainImage : undefined;

  const currentSlideData = slides.find((s) => s.uuid === currentSlide);

  const assetId = useMemo(() => {
    if (!currentMainImage) return;
    // Prefer the user-replaced asset_id (mainImage.assetId !== "default") so
    // the resolved path points at the replacement after reload.
    if (currentMainImage.assetId && currentMainImage.assetId !== "default") {
      return currentMainImage.assetId;
    }
    const placeholders = currentSlideData?.placeholders;
    if (placeholders && "image_element" in placeholders) {
      return placeholders.image_element.asset_id;
    }
  }, [currentMainImage, currentSlideData?.placeholders]);

  // Resolve only when the main image is the selected item (currentMainImage);
  // otherwise this hook reports no media type.
  const mediaType = useMemo(
    () =>
      resolveMainImageMediaType(
        currentMainImage,
        currentMainImage ? currentSlideData : undefined
      ),
    [currentMainImage, currentSlideData]
  );

  const { currentPath } = useRefreshAssetPath({
    assetId: assetId ?? undefined,
    path: undefined,
    autoRefresh: true,
    placeholderAssets,
  });

  return { currentPath, mediaType };
};
